module.exports = __webpack_public_path__ + "img/home-16.464c25b8.webp";